var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full rounded relative"},[_c('gmap-map',{style:(_vm.styles),attrs:{"center":_vm.center,"zoom":7,"map-type-id":"terrain"}},_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }